import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SignatureList from './SignatureList';
import SignLayoff from './SignLayoff';

/**
 * Superintendent side of the layoff flow. The API decides per layoff who can open it,
 * so this is not behind the Manage Layoffs permission.
 */
const LayoffSignatures = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}/:hash`} component={SignLayoff} />
    <Route exact path={match.path} component={SignatureList} />
  </Switch>
);

export default LayoffSignatures;
